<template>
<div class="main--content container">
        <div class="d-flex mt-4 justify-content-between">
            <div>
                <div class="main--content-header content-header">
                <div class="content-header--navbar" >
                    <ul class="content-header--navbar-list">
                        <li class="content-header--navbar-list-item" v-bind:class="page == 'information' ? 'active' : ''">
                            <a class="btn content-header--navbar-list-item-link" @click="page = 'information'">Job Information</a>
                        </li>
                        <li class="content-header--navbar-list-item" v-bind:class="page == 'staff' ? 'active' : ''">
                            <a class="btn content-header--navbar-list-item-link" @click="page = 'staff'">Staff Permissions</a>
                        </li>
                    </ul>
                </div>
            </div>
            </div>

            <div>
                <a v-if="page != 'information'" href="javascript:void(0)" v-on:click="$refs.edit_staff_modal.openModal()" class="btn btn-positive px-5">+ Add Staff</a>
            </div>
        </div>
        <div v-show="page == 'information'" class="mt-3">
            <!--Job Form-->
                <div class="mt-4 col-md-7">
                    <!--Job Name-->
                    <div class="form-group row">
                        <div class="col-md-3">
                            <label class="form-title" for="form-job-name">Job Name:</label>
                        </div>
                        <div class="col-md-6">
                            <input id="form-job-name" class="form-control" placeholder="Name" type="text" v-model="job_edit.name" v-bind:class="hasError('job.name') ? 'is-invalid' : ''">
                            <!-- <span v-if="hasError('job.name')" class="invalid-feedback" role="alert">{{ errors['job.name'].join(' ') }}</span> -->
                        </div>
                    </div>

                    <!--Start Date-->
                    <div class="form-group row">
                        <div class="col-md-3">
                            <label class="form-title">Start Date:</label>
                        </div>

                        <div class="col-md-6">
                            <input type="text" v-model="job_edit.start_date" placeholder="Start date" class="form-control flatpickr input-standard bg-white" v-bind:class="hasError('job.start_date') ? 'is-invalid' : ''">
                            <!-- <span v-if="hasError('job.start_date')" class="invalid-feedback" role="alert">{{ errors['job.start_date'].join(' ') }}</span> -->
                        </div>
                    </div>
                    <!--Client Name-->
                    <search-model
                        ref="searchOrCreateClient"
                        v-model="client_edit"
                        label="Search Client"
                        :selected="client_selected"
                        @select_model="client_selected = true"
                        @unselect_model="client_selected = false"
                        @createNew="createNew"
                        :create_client="create_client"
                        :errors="errors"
                        model_name="client"
                        :model_template="[ {label: 'Client Name', prop: 'create_name'},]"
                        :search_url="client_search_url"
                    ></search-model>

                    <!--Site Name-->
                    <search-model
                        ref="searchSite"
                        v-if="client_selected || create_site"
                        v-model="site_edit"
                        label="Site Name"
                        :selected="site_selected"
                        @select_model="site_selected = true"
                        @unselect_model="site_selected = false"
                        :errors="errors"
                        model_name="site"
                        :create_client="create_client"
                        :create_site="create_site"
                        :model_template="[
                                {label: 'Site Name', prop: 'create_name'},
                                {label: 'Address Line 1', prop: 'address_line_1'},
                                {label: 'Address Line 2', prop: 'address_line_2'},
                                {label: 'City', prop: 'city'},
                                {label: 'Postcode', prop: 'postcode'},
                            ]"
                        :search_url="site_search_url.replace('?', client_edit.id || '?')"
                    ></search-model>
            </div>
        </div>
        <div v-show="page != 'information'" class="mt-3">
            <company-staff-and-permissions
                ref="company_staff_and_permission"
                :create_job = true
                :roles="roles"
                :store_url="store_user_permissions_url"
                :show_user_url="show_user_url"
                :company_staff="staff"
                :loading="loading"
                @getData="getData(false)"
            ></company-staff-and-permissions>
        </div>
        <edit-staff-modal
            @parent_method="getData"
            ref="edit_staff_modal"
            title="Add staff to your company"
            :roles=null
            :company_roles="company_roles"
            :edit_user = false
            :url="store_user_url"
        ></edit-staff-modal>
</div>
</template>

<script>
	import SearchModel from "../general_components/SearchModel";
    import CompanyStaffAndPermissions from "../people/CompanyStaffAndPermissions";
    import EditStaffModal from "../modals/EditStaffModal";
    import JobPeopleAndRoleListing from "../people/JobPeopleAndRoleListing";

	import flatpickr from "flatpickr";
	export default {
		name: "JobCreateEditPage",
		components: { SearchModel, CompanyStaffAndPermissions, EditStaffModal, JobPeopleAndRoleListing},
		props: [
            'job',
            'client',
            'site',
            'temp_job_id',
			'save_url',
            'back_url',
			'client_search_url',
			'site_search_url',
            'store_user_permissions_url',
            'company_staff_url',
            'store_user_url',
            'show_user_url',
            'company_roles',
            'roles',
            'selected',
            'header_content',
            'type',
            'clear_job_url',
        ],

        data(){
			return {
				job_edit: {
					name: '',
                },
				client_edit: {},
				site_edit: {},
				supervisors_edit: [],
                loading: false,
                saving: false,

                errors: [],
                page:null,
                staff:[],
				client_selected: false,
				site_selected: false,

                selected_staff: [],
                create_site: null,
                create_client:null
            }
        },

        beforeMount() {
			if (this.job){ this.job_edit = this.job; }
			if (this.client){ this.client_edit = this.client; }
			if (this.site){ this.site_edit = this.site; }
            if (this.company_staff){ this.staff = this.company_staff; }
            if (this.type){ this.page = this.type; }

            window.addEventListener('LAYOUT:primary_button', this.save);
            window.addEventListener('LAYOUT:cancel_button', this.cancel);
		},

        mounted(){
            this.getData()
			flatpickr('.flatpickr', {
				altInput: true,
				altFormat: "d-m-Y",
				dateFormat: "Y-m-d"
			});

            window.onbeforeunload = () => {
              this.clearJob()
            };
        },

        methods: {
            clearJob(){
				let _this = this;
				if (_this.saving) return;
                _this.saving = true;
                    axios.post(_this.clear_job_url, {
                        temp_job_id: _this.temp_job_id,
                    })
                    .then(function (response){
                    	_this.saving = false;
                    })
                    .catch(function (error){

                    });
            },


            getData(show_loader = true){
                    let _this = this;
                    if(show_loader === true){
                        _this.loading = true;
                    }
                    axios.get(_this.company_staff_url)
                        .then(function (response){
                            _this.loading = false;
                            _this.staff = response.data;
                        });
                },

            createNew(type, createNew){
                if(type == 'client'){
                    if(createNew === false){
                        this.create_client = false
                        this.create_site = false
                        this.$refs.searchSite.createClientSite(this.create_client, this.create_site);
                    } else {
                        this.create_client = true
                        this.create_site = true
                        this.$refs.searchSite.createClientSite(this.create_client, this.create_site);
                    }
                }else if(type == 'site'){
                    this.create_site = true
                }
            },
			hasError(key){
				return !!this.errors[key];
			},

            cancel(){
			   window.location.href = this.back_url.replace('?', '');
            },

            save() {
                this.errors = [];
                if (this.client_edit.create_name != null) {
                    this.client_edit.name = this.client_edit.create_name;
                }
                if (this.site_edit.create_name != null) {
                    this.site_edit.name = this.site_edit.create_name;
                }

                if (this.saving) return;
                this.saving = true;

                axios.post(this.save_url, {
                    temp_job_id: this.temp_job_id,
                    job: this.job_edit,
                    client: this.client_edit,
                    site: this.site_edit,
                })
                .then(response => {
                    this.saving = false;
                    if (this.back_url) {
                        window.location.href = this.back_url.replace('?', response.data.id);
                    } else {
                        Vue.$toast.open({
                            message: 'Job successfully updated',
                            type: 'success'
                        });
                    }
                })
                .catch(error => {
                    this.saving = false;
                    this.handleErrors(error);
                });
            },

            handleErrors(error) {
                if (error.response.data.errors !== undefined) {
                    Object.values(error.response.data.errors).forEach(err => {
                        this.errors.push(`<li>${err[0]}</li>`);
                    });
                }

                if (this.errors.length >= 2) {
                    Vue.$toast.open({
                        message: `There were ${this.errors.length} errors: ${this.errors.join('')}`,
                        type: 'error'
                    });
                } else if (this.errors.length === 1) {
                    Vue.$toast.open({
                        message: `There was an error: ${this.errors.join('')}`,
                        type: 'error'
                    });
                }
            }
        }
	}
</script>
